export default {

    IsNullOrEmpty(s) {
        return (s == undefined || s == null || s.length == 0);
    },

    IsLetter(s) {
        return s.length === 1 && s.match(/[a-zA-Z]/);
    },
    IsUpperCase(s) {
        return s.length === 1 && s.match(/[A-Z]/);
    },

    IsNumber(s) {
        return s.length === 1 && s.match(/[0-9]/);
    },

    ToKebabCase(str) {
        if (this.IsNullOrEmpty(str)) return str;

        let sTemp = str.toLowerCase().trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        let r = "";

        for (let i = 0; i < sTemp.length; i++) {
            let c = sTemp.charAt(i);
            if (this.IsLetter(c)) {
                if (this.IsUpperCase(c)) {
                    r = r + "-" + c.toLowerCase();
                } else {
                    r = r + c;
                }
            }
            else {
                r = r + "-";
            }
        }

        r = r.replace(/-{2,}/, "-");
        r = r.replace(/-+$/, "");
        r = r.replace(/^-+/, "");

        return r.trim();
    },
    
    RemoveAccents(str){
        if (this.IsNullOrEmpty(str)) return str;
        
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');        
    }

}